import React from 'react'
import styled from 'styled-components'

const StyledCard = styled.div`
	width: ${({ width = '12em' }) => width};
	height: ${({ height = '15em' }) => height};
	background-color: ${({ theme, backgroundColor = 'white', selected }) =>
		selected ? theme.main : backgroundColor};
	padding: 1.4em 1.2em;
	border: 2px solid ${({ theme, borderColor = theme.main }) => borderColor};
	border-radius: 26px;
  color: ${({ theme, selected }) => selected ? "white" : theme.main}
`

const Card = ({ children, ...props }) => (
	<StyledCard {...props}>{children}</StyledCard>
)

export default Card



// WEBPACK FOOTER //
// ./src/artzu-ui/src/Card/index.js